import React, { Component } from "react";
import styled from "styled-components";
import ChattyScreen from "./ChattyScreen";
import Image from "../../src/Components/Image";

import GA from "../../src/Utils/GA";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  position: fixed;
  right: 60px;
  bottom: 15px;

  cursor: pointer;
  width: 70px;
  height: 70px;
  border-radius: 50%;

  @media screen and (max-width: 479px) {
    right: 20px;
    bottom: 20px;
  }
`;

const MessageBubble = styled.div`
  width: 218px;
  height: 37px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(214, 185, 161, 0.5);
  border-radius: 17px 17px 5px 17px;
  position: absolute;
  left: -218px;
  top: -20px;
  transition: opacity 400ms;
  opacity: ${props => (props.show ? 1 : 0)};

  & > p {
    font-size: 14px;
    color: #000;
    letter-spacing: 1.4px;
  }
`;

class ChattyButton extends Component {
  state = {
    isBubbleShowed: false,
    isChattyShowed: false
  };

  componentDidMount() {
    this.intervalId = setInterval(() => this._toggBubble(), 1500);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  _toggBubble = () => {
    const { isBubbleShowed } = this.state;

    this.setState({ isBubbleShowed: !isBubbleShowed });
  };

  _toggChatty = () => {
    const { isChattyShowed } = this.state;

    if (!isChattyShowed) {
      this.setState({ isChattyShowed: true, isBubbleShowed: false });
      clearInterval(this.intervalId);
      GA.customEvent("Click", "Chatty", "Open");
    } else {
      this.setState({ isChattyShowed: false });
      this.intervalId = setInterval(() => this._toggBubble(), 2000);
      GA.customEvent("Click", "Chatty", "Close");
    }
  };

  render() {
    const { isBubbleShowed, isChattyShowed } = this.state;

    return (
      <>
        <Wrapper onClick={this._toggChatty}>
          <Image src="../images/daka.png" css={"width: 70px; height: 70px;"} />
          <MessageBubble show={isBubbleShowed}>
            <p>準備來場咖啡配對旅程了嗎？</p>
          </MessageBubble>
        </Wrapper>
        {isChattyShowed && <ChattyScreen toggChatty={this._toggChatty} />}
      </>
    );
  }
}

export default ChattyButton;
